import { FC, ReactNode } from 'react';
import cn from 'classnames';
import styled from 'styled-components';

import { media } from '@/shared/components';
import { COLORS } from '@/shared/constants/colors';
import { Icon } from '@/shared/uikit/Icon';

type EmptyDistributionProps = {
  title: string;
  text: ReactNode;
  icon: 'disc' | 'chart-bar';
  small?: boolean;
};

export const EmptyDistribution: FC<EmptyDistributionProps> = ({ title, text, icon, small }) => {
  return (
    <Container className={cn({ small })}>
      <IconWrapper>
        <Icon name={icon} size="s24" />
      </IconWrapper>
      <TextWrapper>
        <b>{title}</b>
        {text}
      </TextWrapper>
    </Container>
  );
};

const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  align-items: center;
  justify-content: center;
  padding: 24px;
  flex: 1;
  min-width: 340px;

  &.small {
    padding: 0 24px;
    min-width: unset;
  }

  ${media.iwMobile} {
    width: 100%;
    padding: 8px 16px;
  }
`;

const TextWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
  text-align: center;
  color: ${COLORS.systemDark200};
`;

const IconWrapper = styled.div`
  border-radius: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 1px dashed ${COLORS.systemDark100};
  width: 44px;
  height: 44px;
  color: ${COLORS.systemDark100};
`;
